import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import * as S from './style';

const CheckboxGroupInput = ({ name, options }) => {
  const { t } = useTranslation();
  const {
    values: { [name]: checked = [] },
  } = useFormikContext();
  const { variants, tkeys, maxSelection } = options;

  useEffect(() => {
    if (!variants) {
      console.error(name, 'field is missing options!');
    }
  }, []);

  if (!variants) {
    return null;
  }

  return (
    <>
      {tkeys && (
        <S.Caption style={{ flex: '1 1 100%' }}>
          <em>{t(tkeys[0])}</em>
        </S.Caption>
      )}

      {Object.entries(variants).map(([value, text]) => {
        const isChecked = checked.indexOf(value) !== -1;
        const disabled = checked.length === (maxSelection || 3) && !isChecked;

        return (
          <S.CheckboxLabel key={value}>
            <Field name={name} id={name} type="checkbox" value={value} disabled={disabled} />
            <div
              className={`checkbox-style ${
                disabled ? 'checkbox-style--disabled' : isChecked ? 'checkbox-style--checked' : ''
              }`}
            ></div>
            <span
              className={disabled ? `checkbox-label checkbox-label--disabled` : `checkbox-label`}
            >
              {text}
            </span>
          </S.CheckboxLabel>
        );
      })}
    </>
  );
};

export default CheckboxGroupInput;

CheckboxGroupInput.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
};
